<div id="theme_id" class="theme-red">

<section class="height-100vh">
    <div class="display-table slidero">
        <div class="display-table-cell">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-5">
                        <div class="card account-card">
                            <div class="card-body">
                                <div class="text-center mt-3">
									<a href="/" class="navbar-brand logo text-uppercase">
										<img style="width:180px; height: auto;"  src="assets/images/IncluTec.png" alt="IncluTec Logo">
									</a>
                                    <p class="text-muted">Reiniciar contraseña</p>
                                </div>
                                <div class="p-3">
                                    <div class="alert alert-warning  text-center" role="alert">
                                        Ingrese su correo electrónico y le enviaremos las instrucciones.
                                    </div>
                                    <form>
                                        <div class="form-group">
                                            <label for="email">Email</label>
                                            <input type="password" class="form-control" id="email" placeholder="Ingrese Email">
                                        </div>

                                        <div class="mt-3">
                                            <button type="button" class="btn btn-custom btn-block">Reiniciar contraseña</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</div>